import React from 'react';
import loadable from '@loadable/component';
import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { propTypes } from '../../util/types';
import { ASSET_NAME } from './PrivacyPolicyPage.duck';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import css from './PrivacyPolicyPage.module.css';

const PrivacyPolicyContent = props => {
  return (
    <div className={css.root}>
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            'ol{margin:0;padding:0}table td,table th{padding:0}.c1{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:17pt;font-family:"Arial";font-style:normal}.c3{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:"Arial";font-style:normal}.c4{padding-top:0pt;padding-bottom:0pt;line-height:1.15;orphans:2;widows:2;text-align:left;height:11pt}.c2{padding-top:18pt;padding-bottom:4pt;line-height:1.15;orphans:2;widows:2;text-align:left}.c5{padding-top:12pt;padding-bottom:12pt;line-height:1.15;orphans:2;widows:2;text-align:left}.c0{background-color:#ffffff;max-width:451.4pt;padding:72pt 72pt 72pt 72pt}.title{padding-top:0pt;color:#000000;font-size:26pt;padding-bottom:3pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:0pt;color:#666666;font-size:15pt;padding-bottom:16pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Arial"}p{margin:0;color:#000000;font-size:11pt;font-family:"Arial"}h1{padding-top:20pt;color:#000000;font-size:20pt;padding-bottom:6pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-size:16pt;padding-bottom:6pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:16pt;color:#434343;font-size:14pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:14pt;color:#666666;font-size:12pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}',
        }}
      />
      <h2 className="c2" id="h.jo2wnfmm9nf0">
        <span className="c1">1. Wie zijn wij?</span>
      </h2>
      <p className="c5">
        <span className="c3">
          Vaarmarkt.nl is een handelsnaam van:
          <br />
          <br /> Nauticlink B.V.
          <br /> Katwolderweg, 8041 AC Zwolle, Nederland
          <br /> KvK-nummer: 80526314
          <br /> BTW-nummer: NL8617.02.128.B01
          <br /> E-mail: info@vaarmarkt.nl
          <br />
          <br /> Waar in deze verklaring wordt gesproken over “Vaarmarkt”, wordt ook Nauticlink B.V.
          bedoeld als verwerkingsverantwoordelijke in de zin van de AVG.
        </span>
      </p>
      <h2 className="c2" id="h.8mr3esh9lecd">
        <span className="c1">2. Voor wie is deze verklaring bedoeld?</span>
      </h2>
      <p className="c5">
        <span className="c3">
          Deze verklaring geldt voor:
          <br />
          <br /> - Bezoekers van de website www.vaarmarkt.nl en bijbehorende apps;
          <br /> - Gebruikers met een account;
          <br /> - Adverteerders (zowel particulier als zakelijk);
          <br /> - Ontvangers van e-mails of nieuwsbrieven;
          <br /> - Iedereen die via het platform een betaling verricht.
        </span>
      </p>
      <h2 className="c2" id="h.ksliczk1oniz">
        <span className="c1">3. Welke persoonsgegevens verwerken wij?</span>
      </h2>
      <p className="c5">
        <span className="c3">
          Wij verwerken (afhankelijk van je gebruik) de volgende gegevens:
          <br />
          <br /> A. Bij gebruik of registratie:
          <br /> - Voor- en achternaam
          <br /> - Gebruikersnaam
          <br /> - E-mailadres
          <br /> - IP-adres, locatie
          <br /> - Telefoonnummer (optioneel of verplicht)
          <br /> - Wachtwoord (versleuteld)
          <br /> - Status: particulier of zakelijk
          <br />
          <br /> B. Bij advertenties:
          <br /> - Advertentietekst, titel, foto's, locatie
          <br /> - Inhoud en kenmerken van aangeboden objecten
          <br /> - Datum- en tijdgegevens van plaatsing
          <br />
          <br /> C. Bij betalingen (via Stripe):
          <br /> - Betaalmethode (iDEAL, creditcard, SEPA)
          <br /> - Naam, IBAN of kaartnummer (verwerkt door Stripe)
          <br /> - Transactie-ID’s en betalingsstatus
          <br /> - Facturatiegegevens, btw-nummer (zakelijk)
          <br />
          <br /> D. Bij contact:
          <br /> - Klantvragen en berichten
          <br /> - Supportverzoeken of klachten
          <br />
          <br /> E. Websitegebruik:
          <br /> - Klikgedrag en gebruiksstatistieken
          <br /> - Apparaat- en browsergegevens
          <br /> - Cookies (zie verderop)
        </span>
      </p>
      <h2 className="c2" id="h.83m2xtsnz37m">
        <span className="c1">4. Waarvoor gebruiken wij deze gegevens?</span>
      </h2>
      <p className="c5">
        <span className="c3">
          Doel &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Grondslag volgens AVG
          <br /> --------------------------------------|------------------------------------
          <br /> Accountregistratie en inloggen &nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Uitvoering van overeenkomst
          <br /> Plaatsen en beheren van advertenties | Uitvoering van overeenkomst
          <br /> Betalingen verwerken via Stripe
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Uitvoering van overeenkomst
          <br /> Automatische verlenging + incasso&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|
          Uitvoering van overeenkomst
          <br /> Versturen van servicemeldingen &nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Gerechtvaardigd belang
          <br /> Nieuwsbrieven en aanbiedingen &nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Toestemming
          <br /> Klantcontact en ondersteuning &nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Gerechtvaardigd belang
          <br /> Wettelijke administratie &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Wettelijke verplichting
          <br /> Analyse en verbetering van de site &nbsp; | Gerechtvaardigd belang
          <br />
          <br /> Wij nemen geen geautomatiseerde besluiten over jou die rechtsgevolgen hebben of jou
          anderszins in aanmerkelijke mate treffen. Ook maken wij geen gebruik van profilering in de
          zin van de AVG.
        </span>
      </p>
      <h2 className="c2" id="h.m6kdzp29p4m4">
        <span className="c1">5. Automatische verlenging en incasso</span>
      </h2>
      <p className="c5">
        <span className="c3">
          Wanneer je kiest voor een advertentie met automatische verlenging, wordt na afloop van de
          looptijd het bedrag automatisch opnieuw geïncasseerd via Stripe. Je ontvangt hierover
          tijdig bericht. Deze functie kan op elk moment worden uitgeschakeld via je
          accountinstellingen.
        </span>
      </p>
      <h2 className="c2" id="h.vxr192udqvt1">
        <span className="c1">6. Wie hebben toegang tot jouw gegevens?</span>
      </h2>
      <p className="c5">
        <span className="c3">
          Wij delen jouw gegevens alleen met derden indien dat noodzakelijk is voor onze
          dienstverlening:
          <br />
          <br /> Ontvanger &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Doel &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Locatie
          <br />{' '}
          ----------------------------------|-------------------------------------|----------------------------
          <br /> Stripe &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Betalingen en automatische
          incasso &nbsp;| EU/VS (onder EU-US DPF)
          <br /> Hostingproviders &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Beheer en opslag van data &nbsp; &nbsp;
          &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| EU
          <br /> E-mailproviders &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Verzenden van berichten &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| EU
          <br /> Analyticsdiensten (bijv. Matomo, GA)| Gebruik meten en analyseren &nbsp; &nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| EU / VS met waarborgen
          <br /> Overheidsinstanties (zoals fiscus) | Wettelijke verplichtingen &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Nederland
          <br />
          <br /> Met deze partijen hebben wij verwerkersovereenkomsten gesloten. Zij verwerken jouw
          gegevens uitsluitend in onze opdracht.
        </span>
      </p>
      <h2 className="c2" id="h.kkfbrfpm0hce">
        <span className="c1">7. Beveiliging van gegevens</span>
      </h2>
      <p className="c5">
        <span className="c3">
          Wij nemen passende technische en organisatorische maatregelen om je gegevens te
          beschermen, waaronder:
          <br />
          <br /> - SSL-versleuteling (HTTPS)
          <br /> - Sterke wachtwoordbeveiliging
          <br /> - Interne toegangscontrole
          <br /> - Monitoring en logbestanden
          <br /> - Regelmatige updates van systemen
        </span>
      </p>
      <h2 className="c2" id="h.7cjxezanucm">
        <span className="c1">8. Cookies en vergelijkbare technieken</span>
      </h2>
      <p className="c5">
        <span className="c3">
          Wij gebruiken cookies voor:
          <br />
          <br /> - Functioneel gebruik van het platform
          <br /> - Statistische analyse
          <br /> - Gepersonaliseerde content en advertenties (alleen met toestemming)
          <br />
          <br /> Bij je eerste bezoek vragen we via een cookiebanner om toestemming. Je kunt cookies
          verwijderen of instellen via je browser. Zie onze [cookieverklaring] voor een overzicht
          van gebruikte cookies.
        </span>
      </p>
      <h2 className="c2" id="h.ni4uhf7zyphk">
        <span className="c1">9. Hoe lang bewaren wij jouw gegevens?</span>
      </h2>
      <p className="c5">
        <span className="c3">
          Type gegevens &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|
          Bewaartermijn
          <br /> --------------------------|---------------------------------------------
          <br /> Accountgegevens &nbsp; &nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Tot opzegging + max. 1 jaar
          <br /> Advertentiegegevens &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Tot 60
          dagen na afloop, daarna geanonimiseerd
          <br /> Betalings-/factuurgegevens| 7 jaar (fiscale bewaarplicht)
          <br /> Klantcontact en support &nbsp;| Max. 2 jaar
          <br /> Nieuwsbriefgegevens &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Tot
          afmelding
          <br /> Cookies &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| Zie cookieverklaring (max. 26
          maanden)
        </span>
      </p>
      <h2 className="c2" id="h.pk6oym1pti5u">
        <span className="c1">10. Jouw rechten</span>
      </h2>
      <p className="c5">
        <span className="c3">
          Je hebt onder de AVG recht op:
          <br />
          <br /> - Inzage in je persoonsgegevens
          <br /> - Correctie van onjuiste gegevens
          <br /> - Verwijdering (‘recht op vergetelheid’)
          <br /> - Beperking van verwerking
          <br /> - Overdracht van je gegevens (data portabiliteit)
          <br /> - Bezwaar tegen verwerking op basis van gerechtvaardigd belang
          <br /> - Intrekking van toestemming (bijv. voor nieuwsbrieven)
          <br />
          <br /> Verzoeken kun je sturen naar: info@vaarmarkt.nl <br /> We reageren uiterlijk binnen
          30 dagen.
        </span>
      </p>
      <h2 className="c2" id="h.vb299htxigr2">
        <span className="c1">11. Klachten</span>
      </h2>
      <p className="c5">
        <span className="c3">
          Ben je niet tevreden over hoe wij omgaan met je gegevens? Neem contact met ons op via
          info@vaarmarkt.nl. Je kunt ook een klacht indienen bij de Autoriteit Persoonsgegevens via
          www.autoriteitpersoonsgegevens.nl.
        </span>
      </p>
      <h2 className="c2" id="h.kxtzjsqzt1ph">
        <span className="c1">12. Wijzigingen in deze verklaring</span>
      </h2>
      <p className="c5">
        <span className="c3">
          We kunnen deze verklaring van tijd tot tijd wijzigen, bijvoorbeeld bij wetswijzigingen of
          platformaanpassingen. De laatste versie is altijd beschikbaar op www.vaarmarkt.nl/privacy.
          Bij grote wijzigingen informeren wij je per e-mail of binnen het platform.
        </span>
      </p>
      <p className="c4">
        <span className="c3" />
      </p>
    </div>
  );
};

const PrivacyPolicyPageComponent = props => {
  const { scrollingDisabled } = props;

  return (
    <Page title="Vaarmarkt Voorwaarden" scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        mainColumnClassName={css.layoutWrapperMain}
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <PrivacyPolicyContent />
      </LayoutSingleColumn>
    </Page>
  );
};

PrivacyPolicyPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error, scrollingDisabled: isScrollingDisabled(state) };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const PrivacyPolicyPage = compose(connect(mapStateToProps))(PrivacyPolicyPageComponent);

const PRIVACY_POLICY_ASSET_NAME = ASSET_NAME;
export { PRIVACY_POLICY_ASSET_NAME, PrivacyPolicyPageComponent, PrivacyPolicyContent };

export default PrivacyPolicyPage;
